import { createSlice, PayloadAction } from '@reduxjs/toolkit'

// types
type CartItemId = string

type CartItemQuantity = number

export type CartItem = {
  id: CartItemId,
  quantity: CartItemQuantity,
}

type IsModalOpen = boolean

type InitialState = {
  itemsInCart: CartItem[],
  isModalOpen: IsModalOpen,
}

const initialState: InitialState = {
  itemsInCart: [],
  isModalOpen: false,
}

const getProductQuantity = ({
  id,
  itemsInCart,
}:{
  id: CartItemId,
  itemsInCart: CartItem[],
}):CartItemQuantity => {
  const quantity = itemsInCart
    .find((item: CartItem) => item.id === id)
    ?.quantity

  return quantity ? quantity : 0
}

const cartSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    // - what changed from redux to redux-toolkit?
    //    1) we don't have to explicitly return new state
    //    2) we can directly mutate state
    // - how is this possible?
    //    under the hood createSlice uses the immur module (see redux-demo/)
    addOneToCart: (state, action: PayloadAction<CartItemId>) => {
      const id = action.payload
      const itemsInCart = state.itemsInCart

      const quantity = getProductQuantity({ id, itemsInCart })

      // console.log({ quantity })

      const isProductNotInCart = (quantity === 0)

      if (isProductNotInCart) {
        state.itemsInCart = [
          ...itemsInCart,
          { id, quantity: 1 },  // add for 1st time
        ]
      } else {
        state.itemsInCart.map((item:CartItem) => {
          return (item.id === id)
            ? { ...item, quantity: ++item.quantity }
            : item
        })
      }
    },
    deleteItemFromCart: (state, action: PayloadAction<CartItemId>) => {
      const id = action.payload

      state.itemsInCart = state.itemsInCart
        .filter(item => (item.id !== id))
    },
    removeOneFromCart: (state, action: PayloadAction<CartItemId>) => {
      const id = action.payload
      const itemsInCart = state.itemsInCart

      const quantity = getProductQuantity({ id, itemsInCart })

      const onlyOneProductInCart = (quantity === 1)

      if (onlyOneProductInCart) {
        state.itemsInCart = state.itemsInCart
          .filter(item => (item.id !== id))
      } else {
        state.itemsInCart.map((item: CartItem) => {
          return (item.id === id)
            ? { ...item, quantity: --item.quantity }
            : item
        })
      }
    },
    openOrCloseModal: state => {
      state.isModalOpen = !state.isModalOpen
    },
  },
})

export default cartSlice.reducer
export const {
  addOneToCart,
  deleteItemFromCart,
  removeOneFromCart,
  openOrCloseModal,
} = cartSlice.actions
